import { Injectable } from '@angular/core';
import { AbstractControl, UntypedFormControl, UntypedFormGroup, ValidationErrors, ValidatorFn } from '@angular/forms';

@Injectable({
  providedIn: 'root'
})
export class ValidatorsService {

  constructor() { }
  regexValidator(regex: RegExp, error: ValidationErrors): ValidatorFn {
    return (control: AbstractControl): {[key: string]: any} => {
      if (!control.value) {
        return null;
      }
      const isWhitespace = (control.value || '').trim().length === 0;
      // Whitespace detect
      if(isWhitespace) {
        control.setValue(control.value.trim());
        return {required: true};
      } else {
        const valid = regex.test(control.value.trim());
        return valid ? null : error;  
      }
    };
  }

  // Password and Confirm password matcher
  passwordMatcher(): ValidatorFn {
    return (control: UntypedFormGroup): any => {
    const pass = control.get('password');
    const confirm = control.get('confirmPassword');
    return pass && confirm && pass.value !== confirm.value ? { notMatch: true } : null;
    }
  }  

    // To validate all fields in the form group
    validateAllFields(formGroup: UntypedFormGroup) {
     return Object.keys(formGroup.controls).forEach(field => {
       if(formGroup.get(field).value && (formGroup.get(field).value == true || formGroup.get(field).value == false)){
        formGroup.get(field).setValue(formGroup.get(field).value ? formGroup.get(field).value : formGroup.get(field).value);// This line of code will trim the whitespaces before and after before validate
       }
       else{
        formGroup.get(field).setValue(formGroup.get(field).value ? formGroup.get(field).value.trim() : formGroup.get(field).value); // This line of code will trim the whitespaces before and after before validate
       }
        const control = formGroup.get(field);
        if (control instanceof UntypedFormControl) {
          control.markAsTouched({ onlySelf: true });
        } else if (control instanceof UntypedFormGroup) {
          this.validateAllFields(control);
        }
      });
    }
  
    // To trim the form group
    cleanForm(formGroup: UntypedFormGroup) {
      Object.keys(formGroup.controls).forEach((field) => formGroup.get(field).setValue(formGroup.get(field).value ? formGroup.get(field).value.trim() : formGroup.get(field).value));
    }
  
    /* ****************  Define all your regex validators below ************* */
    // Alpha numberic with ',' '.' are allowed, Maximum lenth allowed is 30 characters
    alphaNum30() {
      const alphaNumericwithCommonSpecialCharactersMaxLength30: RegExp = /^([a-zA-Z0-9_ \-,.\r\n]){0,30}$/;
      return this.regexValidator(alphaNumericwithCommonSpecialCharactersMaxLength30, {alphaNum30: true});
    }
    enrollno() {
      const NumericwithCommonSpecialCharactersMaxLength12: RegExp = /^([0-9]){12}$/;
      return this.regexValidator(NumericwithCommonSpecialCharactersMaxLength12, {enrollno: true});
    }
     // Alpha numberic with ',' '.' are allowed, Maximum lenth allowed is 30 characters
    mobile() {
      // const alphaNumericwithCommonSpecialCharactersMaxLength30: RegExp = /^([0-9_ \-,.\r\n]){0,10}$/;
      const alphaNumericwithCommonSpecialCharactersMaxLength30: RegExp = /[1-9]{1}[0-9]{9}/;
      // const alphaNumericwithCommonSpecialCharactersMaxLength30: RegExp = /^\+[1-9]{1}[0-9]{3,14}$/;
      return this.regexValidator(alphaNumericwithCommonSpecialCharactersMaxLength30, {alphaNum30: true});
    }
    mobileRegex() {
      const mobileRegex: RegExp = /^[6-9][0-9]{9}$/;
      return this.regexValidator(mobileRegex, {mobileRegex: true});
    }
    // Email pattern regex
    email() {
      const emailregex: RegExp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return this.regexValidator(emailregex, {email: true});
    }
    passwordRegex(){
      const passwordHard: RegExp = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-])(?=.*?^[A-Za-z0-9!<>?/{}\|+-_=@#%$^*()]*$)/;
      return this.regexValidator(passwordHard, {password: true});
    }

    //First Name and Last name Validators
    alpha30() {
      const alpha: RegExp = /^([a-zA-Z]){0,30}$/;
      return this.regexValidator(alpha, {alpha30: true});
    }

    namewithSpecialCharacters() {
      const nospace: RegExp = /^([\sa-zA-Z0-9.,&()'"-]){3,100}$/;
      return this.regexValidator(nospace, {dummymsg: true});
  }
}
